import type { ProductDto } from "../../types/ProductDto";
import type { ProductEntity } from "../../types/ProductEntity";

export const ProductEntityToDto = ({ ...rest }: Readonly<ProductEntity>): ProductDto => {
    return { ...rest };
};
